const fallbackCreations = [
  {
    type: "portfolio",
    title: "Portfolioo",
    url: "https://prudhvi-kollana-portfolio.vercel.app/",
    label: "Personal Portfolio",
    description: "Central hub showcasing my work, timeline & achievements.",
    icon: "Grid",
    tags: ["About Me", "Showcase", "Resume"],
    image: "/images/portfolio_img.png",
    display: true,
    order: 1,
    is_hub: false,
    is_status: false,
  },
  {
    type: "invoice-labs",
    title: "Invoice Labs",
    url: "https://invoicelabs.vercel.app",
    label: "Premium Billing",
    description: "Premium invoice & bill generator. Craft professional invoices in seconds with customizable templates, signatures and one-click PDF export.",
    icon: "Rupee",
    tags: ["Invoice", "Bill", "Freelancer"],
    image: "/images/invoice_labs_img.png",
    display: true,
    order: 2,
    is_hub: false,
    is_status: false,
  },
  {
    type: "widget",
    title: "PK Widget",
    url: "https://pkwidget.vercel.app",
    label: "Smart Web Widgets",
    description: "Lightweight widget platform for developers to create, customize, and share embeddable UI components.",
    icon: "Sparkle",
    tags: ["Low-code tools", "Productivity", "Interactive"],
    image: "/images/pk_widget_img.png",
    display: true,
    order: 3,
    is_hub: false,
    is_status: false,
  },
  {
    type: "score-dash-board",
    title: "ScoreDashBoard",
    url: "https://score-dash-board.vercel.app/",
    label: "Smart Dashboard",
    description:
      "A real-time game session dashboard to organize matches, generate AI teams or players, balance squads and track scores with live rankings and stats.",
    icon: "Monitor",
    tags: [
      "Live Scores",
      "AI Teams",
      "AI Players",
      "Team Balancing",
      "Leaderboard",
      "Multi-mode",
    ],
    image: "/images/score_dash_board_img.png",
    display: true,
    order: 4,
    is_hub: false,
    is_status: false,
  },
  {
    type: "mini-score-board",
    title: "MiniScoreBoard",
    url: "https://my-score-board.vercel.app/",
    label: "Mini ScoreBoard",
    description:
      "A fast, lightweight score tracker for quick games, challenges, and friendly matches.",
    icon: "List",
    tags: ["Real-time", "Scorekeeping", "Game Tool"],
    image: "/images/mini_score_board_img.png",
    display: true,
    order: 5,
    is_hub: false,
    is_status: false,
  },
  {
    type: "housiee",
    title: "Housiee",
    url: "https://housiee.vercel.app/",
    label: "Game",
    description: "Interactive online housie game built for fun sessions.",
    icon: "Gamepad2",
    tags: ["Fun", "Party", "Multiplayer"],
    image: "/images/housiee_img.png",
    display: true,
    order: 6,
    is_hub: false,
    is_status: false,
  },
  {
    type: "tally",
    title: "Tally",
    url: "https://tally-play.vercel.app/",
    label: "Puzzle",
    description: "A mini interactive maths game built for casual brain play.",
    icon: "Cpu",
    tags: ["Focus", "Time-pass", "Prototype"],
    image: "/images/tally_img.png",
    display: true,
    order: 7,
    is_hub: false,
    is_status: false,
  },
  {
    type: "spin-out",
    title: "SpinOut",
    url: "https://try-spinout.vercel.app/",
    label: "Party Game",
    description: "Truth or dare prompts for quick ice-breakers & parties.",
    icon: "Puzzle",
    tags: ["Engage", "Social", "Entertainment"],
    image: "/images/spin_out_img.png",
    display: true,
    order: 8,
    is_hub: false,
    is_status: false,
  },
  {
    type: "zip-game",
    title: "ZipWay",
    url: "https://zip-way.vercel.app/",
    label: "Path Puzzle Mastery",
    description: "Clean and addictive logic puzzle game designed to challenge your brain while keeping you relaxed",
    icon: "Zap",
    tags: ["Strategy", "Brain", "Path"],
    image: "/images/zip_way_img.png",
    display: true,
    order: 9,
    is_hub: false,
    is_status: false,
  },
  {
    type: "portfolio-status-hub",
    title: "PortfolioStatusHub",
    url: "https://portfolio-status-hub.vercel.app/",
    label: "Live Status",
    description: "Real-time system health, uptime tracking and outage reports.",
    icon: "Activity",
    tags: ["Monitoring", "Incidents", "Operations"],
    image: "/images/status_hub_img.png",
    display: true,
    order: 10,
    is_hub: false,
    is_status: true,
  },
    {
    type: "portfolio-hub",
    title: "PortfolioHub",
    url: "https://prudhvi-kollana-portfolio-hub.vercel.app/",
    label: "Portfolio Hub",
    description: "Portfolio hub showcasing all creations.",
    icon: "Globe",
    tags: [
      "Showcase",
      "Hub"
    ],
    image: "/images/portfolio_hub_img.png",
    display: false,
    order: 9,
    is_hub: true,
    is_status: false,
  },
  {
    type: "emi-master",
    title: "EMIMaster",
    url: "https://emi-master.vercel.app/",
    label: "Finance Tool",
    description: "Advanced EMI calculator with real-time visual insights.",
    icon: "BarChart2",
    tags: ["Planning", "Loans", "Calculator"],
    image: "/images/emi_master_img.png",
    display: true,
    order: 11,
    is_hub: false,
    is_status: false,
  },
];

export default fallbackCreations;
